module.exports = __webpack_public_path__ + "img/presidentialsweet_room_feature02.db7cce00.jpg";